module.exports = __webpack_public_path__ + "static/assets/216bff32a62daca1ac91f999668d3eb8.png";